<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <popover v-if="info" class="float-right" placement="bottom-end">
      <template #default>
        <font-awesome-icon icon="fa-circle-info" class="text-gray-600 cursor-pointer" />
      </template>
      <template #dropdown>
        <div class="bg-primary text-white text-sm p-4 max-w-[250px] max-h-[300px] shadow-lg overflow-x-hidden overflow-y-auto scrollbar-thin scrollbar-thumb-blue-900 scrollbar-track-gray-200">
          {{ info }}
        </div>
      </template>
    </popover>
    
    <div class="relative flex items-center gap-1 form-input">
      <label :for="id">
        <font-awesome-icon icon="fa-regular fa-clock" @click="() => this.$refs.timeinput.openMenu()" />
      </label>

      <input ref="input" v-mask="'##:##'" :id="id" class="w-full" v-bind="{ ...$attrs, class: null }" :class="{ error: error }" type="tel" :value="this.inputValue" @change="changeTime" @keyup="keyup" autocomplete="off" />
    </div>

    <Datepicker ref="timeinput" v-model="this.value" modelType="HH:mm" :clearable="false" :format="format" :class="{ error: error }" timePicker locale="pt-BR">
      <template #dp-input="{ value, onInput, onEnter, onTab, onClear }">
      </template>
      <template #action-select>
        <button class="btn-primary px-6 py-2.5 text-xs leading-tight uppercase ml-1" @click="selectDate" type="submit">Selecionar</button>
      </template>
      <template #action-preview="{ value }">
      </template>
    </Datepicker>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import ptBR from 'date-fns/locale/pt-BR';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import {mask, TheMask} from 'vue-the-mask'
import Popover from '@/Shared/Components/Popover'

export default {
  data() {
    return {
      value: null,
      inputValue: null,
    }
  },
  mounted() {
    if(this.modelValue) {
      this.inputValue = this.modelValue;
      let time = this.modelValue.split(':');
      this.value = {
        hours: time[0],
        minutes: time[1],
        seconds: 0,
      };
    }
  },
  watch: {
    value(valueNew, valueOld) {

      
      
      let modelValue = null;
      if(this.value) {
        modelValue = this.value.hours.toString().padStart(2, '0') + ':' + this.value.minutes.toString().padStart(2, '0');
      }
      this.inputValue = modelValue;
      this.$emit('update:modelValue', modelValue);
    },
  },
  components: {
    Datepicker,
    ptBR,
    format,
    parse,
    TheMask,
    Popover,
  },
  directives: {
    mask
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    info: {
      type: String,
      default: '',
    },
    error: String,
    label: String,
    modelValue: String,
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      console.log('select')
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      console.log('range')
      this.$refs.input.setSelectionRange(start, end)
    },
    format (date){
      let input = '';

      if(date && date.hours && date.minutes){
        input = date.hours.toString().padStart(2, '0') + ':' + date.minutes.toString().padStart(2, '0');
      }
      
      return input;

    },
    /*format(date) {
      return date.hours + ':' + date.minutes;
    },*/
    keyup(input) {
      this.$refs.timeinput.closeMenu();
    },
    changeTime(input) {
      console.log(input.target.value)
      let time = input.target.value;
      let hours = time.substr(0, 2);
      let minutes = time.substr(3, 2);
      if(time.length && hours < 24 && minutes < 60) {
        this.value = {
          hours: hours,
          minutes: minutes,
          seconds: 0,
        };
      } else {
        this.value = null;
      }
    },
    selectDate(timeinput) {
      console.log(timeinput.target.value)
      
      this.$refs.timeinput.selectDate();

      
    }
  },
}
</script>
